// C:\Users\purplehat\Desktop\payment-cookie-system\frontend\src\components\BottomNav.js

import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  HomeIcon,
  ShoppingBagIcon,
  PlusCircleIcon,
  ChartBarIcon,
  UserIcon,
  CreditCardIcon,
  ShieldCheckIcon,
  ShoppingCartIcon,
  BoltIcon,
  PhoneIcon,
  UserPlusIcon,
  DevicePhoneMobileIcon
} from '@heroicons/react/24/outline';
import {
  HomeIcon as HomeIconSolid,
  ShoppingBagIcon as ShoppingBagIconSolid,
  PlusCircleIcon as PlusCircleIconSolid,
  ChartBarIcon as ChartBarIconSolid,
  UserIcon as UserIconSolid,
  CreditCardIcon as CreditCardIconSolid,
  ShieldCheckIcon as ShieldCheckIconSolid,
  ShoppingCartIcon as ShoppingCartIconSolid,
  BoltIcon as BoltIconSolid,
  PhoneIcon as PhoneIconSolid,
  UserPlusIcon as UserPlusIconSolid,
  DevicePhoneMobileIcon as DevicePhoneMobileIconSolid
} from '@heroicons/react/24/solid';
import { WalletIcon } from '@heroicons/react/24/outline';
import { WalletIcon as WalletIconSolid } from '@heroicons/react/24/solid';
import { ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';
import { ChatBubbleLeftRightIcon as ChatBubbleLeftRightIconSolid } from '@heroicons/react/24/solid';

function BottomNav({ unreadMessages = 0 }) {
  const location = useLocation();

  const userStr = localStorage.getItem('user');
  let user = null;
  try {
    user = userStr ? JSON.parse(userStr) : null;
  } catch (e) {}

  const isAdmin = user?.role === 'admin' || user?.role === 'owner';

  const navItems = [
    { path: '/', label: 'Inicio', icon: HomeIcon, iconActive: HomeIconSolid },
    { path: '/cookies', label: 'Cookies', icon: ShoppingBagIcon, iconActive: ShoppingBagIconSolid },
    { path: '/cards', label: 'Tarjetas', icon: CreditCardIcon, iconActive: CreditCardIconSolid },
    { path: '/amazon-cards', label: 'checkr', icon: BoltIcon, iconActive: BoltIconSolid },
    { path: '/amazon-create', label: 'Crear Cta', icon: UserPlusIcon, iconActive: UserPlusIconSolid }, // 🆕 NUEVA SECCIÓN
    { 
      path: '/chat', 
      label: 'Chat', 
      icon: ChatBubbleLeftRightIcon, 
      iconActive: ChatBubbleLeftRightIconSolid,
      badge: unreadMessages
    },
    { path: '/amazon-auto', label: 'Auto', icon: ShoppingCartIcon, iconActive: ShoppingCartIconSolid },
    ...(isAdmin ? [{ path: '/admin', label: 'Admin', icon: ShieldCheckIcon, iconActive: ShieldCheckIconSolid }] : []),
    { path: '/statistics', label: 'Stats', icon: ChartBarIcon, iconActive: ChartBarIconSolid },
    { path: '/profile', label: 'Perfil', icon: UserIcon, iconActive: UserIconSolid },
    { path: '/sms', label: 'SMS', icon: DevicePhoneMobileIcon, iconActive: DevicePhoneMobileIconSolid },
    { path: '/virtual-operator', label: 'bot otp', icon: PhoneIcon, iconActive: PhoneIconSolid },
  ];

  return (
    <>
      <nav style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        background: 'rgba(10, 10, 10, 0.95)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        borderTop: '1px solid #222222',
        padding: '0.5rem 0.25rem',
        paddingBottom: 'max(0.5rem, env(safe-area-inset-bottom))',
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        zIndex: 50,
        overflowX: 'auto',
        gap: '0.1rem',
        boxShadow: '0 -4px 20px rgba(0,0,0,0.5)'
      }}>
        {navItems.map((item) => {
          const isActive = location.pathname === item.path || 
            (item.path !== '/' && location.pathname.startsWith(item.path));
          const Icon = isActive ? item.iconActive : item.icon;
          
          // 🆕 Estilo especial para "Crear Cta"
          const isCreateAccount = item.path === '/amazon-create';
          
          return (
            <Link
              key={item.path}
              to={item.path}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '0.2rem',
                color: isActive ? '#00ffff' : '#6b7280',
                padding: '0.35rem 0.25rem',
                borderRadius: '0.75rem',
                flex: '0 1 auto',
                minWidth: '3.5rem',
                maxWidth: '5rem',
                textDecoration: 'none',
                background: isActive 
                  ? (isCreateAccount ? 'rgba(255, 153, 0, 0.15)' : 'rgba(0, 255, 255, 0.08)')
                  : 'transparent',
                transition: 'all 0.2s ease',
                position: 'relative',
                ...(isCreateAccount && !isActive ? {
                  border: '1px solid rgba(255, 153, 0, 0.3)',
                } : {})
              }}
              onMouseEnter={(e) => {
                if (!isActive) {
                  e.currentTarget.style.color = '#d1d5db';
                  e.currentTarget.style.background = isCreateAccount 
                    ? 'rgba(255, 153, 0, 0.08)' 
                    : 'rgba(255,255,255,0.03)';
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive) {
                  e.currentTarget.style.color = '#6b7280';
                  e.currentTarget.style.background = 'transparent';
                }
              }}
            >
              {/* Icono con badge */}
              <div style={{ position: 'relative', display: 'inline-flex' }}>
                <Icon style={{ 
                  width: '1.3rem', 
                  height: '1.3rem',
                  transition: 'transform 0.2s',
                  transform: isActive ? 'scale(1.1)' : 'scale(1)',
                  color: isCreateAccount && isActive ? '#ff9900' : undefined
                }} />
                
                {/* Badge de notificaciones */}
                {item.badge !== undefined && item.badge > 0 && (
                  <span style={{
                    position: 'absolute',
                    top: '-8px',
                    right: '-12px',
                    background: 'linear-gradient(135deg, #ff0033, #ff3366)',
                    color: '#ffffff',
                    fontSize: '0.6rem',
                    fontWeight: 'bold',
                    minWidth: '18px',
                    height: '18px',
                    borderRadius: '9px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '0 5px',
                    border: '2px solid #0a0a0a',
                    boxShadow: '0 0 12px rgba(255,0,51,0.6), 0 0 4px rgba(255,0,51,0.3)',
                    animation: item.badge > 0 ? 'notifPulse 2s ease-in-out infinite' : 'none',
                    zIndex: 5,
                    lineHeight: '1'
                  }}>
                    {item.badge > 99 ? '99+' : item.badge}
                  </span>
                )}
              </div>
              
              <span style={{ 
                fontSize: '0.6rem', 
                fontWeight: isActive ? '600' : '400',
                textAlign: 'center',
                whiteSpace: 'nowrap',
                lineHeight: '1',
                color: isCreateAccount && isActive ? '#ff9900' : undefined
              }}>
                {item.label}
              </span>
              
              {/* Indicador activo */}
              {isActive && (
                <div style={{
                  position: 'absolute',
                  bottom: '-0.3rem',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: '16px',
                  height: '3px',
                  background: isCreateAccount 
                    ? 'linear-gradient(90deg, #ff9900, #ff6600)' 
                    : 'linear-gradient(90deg, #00ffff, #ff00ff)',
                  borderRadius: '2px',
                  boxShadow: isCreateAccount 
                    ? '0 0 8px rgba(255, 153, 0, 0.5)' 
                    : '0 0 8px rgba(0,255,255,0.5)'
                }} />
              )}
            </Link>
          );
        })}
      </nav>
      
      <style>{`
        @keyframes notifPulse {
          0% { 
            box-shadow: 0 0 12px rgba(255,0,51,0.6), 0 0 4px rgba(255,0,51,0.3);
            transform: scale(1);
          }
          50% { 
            box-shadow: 0 0 20px rgba(255,0,51,0.9), 0 0 8px rgba(255,0,51,0.5);
            transform: scale(1.1);
          }
          100% { 
            box-shadow: 0 0 12px rgba(255,0,51,0.6), 0 0 4px rgba(255,0,51,0.3);
            transform: scale(1);
          }
        }
      `}</style>
    </>
  );
}

export default BottomNav;